import React, { ReactElement } from 'react';
import coverImage from '../../assets/images/sbe-login-cover.png';
import useReturnUrl from '../../hooks/useReturnUrl';
import IconClose from '../atoms/IconClose';


export default function CardHeader(): ReactElement {
  const returnUrl = useReturnUrl();

  return (
    <div className="card-header text-center">
      {!!returnUrl
        && <button
            className='close-button'
            title="esci"
            onClick={() => window.location.href = returnUrl}
          >
          <IconClose />
        </button>}
        
        <img className="w-100" src={coverImage} />
    </div>
  );
}
